import { Grid, Box, makeStyles } from '@material-ui/core';
import React, { useState, useContext } from 'react';
import SubquestionBox from '../SubquestionBox';
import FiltersContext from '../../contexts/FiltersContext';
import FiltersPoverty from './FiltersPoverty';
import PercentOfPriceAndPercentOfMedianIncomePoverty from './PercentOfPriceAndPercentOfMedianIncomePoverty';
import StateStatsPoverty from './StateStatsPoverty';
import StoryContext from '../../contexts/StoryContext';
import ErrorBoundary from '../ErrorBoundary';

function Q2Row1() {
  const [familyType, setFamilyType] = useState('Family of 3');
  const [settingType, setSettingType] = useState('All');
  const [childAge, setChildAge] = useState('All');

  const { lightColor } = useContext(StoryContext);

  const classes = makeStyles((theme) => ({
    filtersGrid: {
      '@media print': {
        display: 'none',
      },
    },
  }))();

  return (
    <FiltersContext.Provider value={{
      familyType, setFamilyType, settingType, setSettingType, childAge, setChildAge,
    }}
    >
      <SubquestionBox color={lightColor}>
        <Grid container spacing={2}>
          <Grid item xs={12} className={classes.filtersGrid}>
            <Box displayPrint="none">
              <FiltersPoverty />
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <ErrorBoundary>
              <StateStatsPoverty />
            </ErrorBoundary>
          </Grid>
          <Grid item xs={12} sm={6}>
            <ErrorBoundary>
              <PercentOfPriceAndPercentOfMedianIncomePoverty />
            </ErrorBoundary>
          </Grid>
        </Grid>

      </SubquestionBox>
    </FiltersContext.Provider>
  );
}

export default Q2Row1;
